import {ComponentProps} from 'react';
import {twMerge} from 'tailwind-merge';

import CloseIcon from '@/assets/icons/cross.svg?react';

type ModalHeaderProps = ComponentProps<'div'> & {
  onClose?: () => void;
};

function ModalHeader({
  children,
  onClose,
  className,
  ...props
}: ModalHeaderProps) {
  return (
    <div
      className={twMerge(
        'flex w-full items-start gap-4 text-start shadow-md',
        className
      )}
      {...props}
    >
      <div className='flex-1'>
        {children}
      </div>
      {onClose && (
        <button
          className="text-gray-500 hover:text-gray-700 focus:outline-hidden"
          onClick={onClose}
        >
          <CloseIcon className="h-6 w-6" />
        </button>
      )}
    </div>
  );
}

export default ModalHeader;
